<template>
  <div class="testimonial" :style="{ 'grid-area': `testimonial-${index}` }">
    <div class="stars">
      <img
        class="star"
        v-for="star in 5"
        :key="star"
        src="@/assets/images/icons/star/star_trustpilot.svg"
        alt="star"
      />
    </div>
    <h4 class="title">{{ testimonial.title }}</h4>
    <p class="description">{{ testimonial.description }}</p>
    <div class="user">
      <img :src="testimonial.avatar" alt="avatar" />
      <span class="username">{{ testimonial.username }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["testimonial", "index"],
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
.testimonial {
  background: #ffffff;
  box-shadow: 0rem 0rem 1rem rgba(0, 0, 0, 0.15);
  border-radius: 1rem;
  padding: 2.2rem;
  text-align: left;
  width: 38.7rem;
  display: inline-block;
  margin-bottom: 2rem;
  @include phone-down {
    width: 100%;
  }
  &:nth-of-type(1) {
    margin-top: 3.2rem;
  }
  &:nth-of-type(3) {
    margin-top: 3.2rem;
    @include desktop-down {
      margin-top: 0;
    }
  }
  &:nth-of-type(5) {
    margin-top: 3.2rem;
    @include desktop-down {
      margin-top: 0;
    }
  }
  &:nth-of-type(4) {
    margin-top: 0;
    @include desktop-down {
      margin-top: 3.2rem;
      @include phone-down {
        margin-top: 0;
      }
    }
  }
  .stars {
    display: flex;
    gap: 0.2rem;
  }
  .title {
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: #0b0a1c;
    margin-top: 1.3rem;
  }
  .description {
    font-weight: 300;
    font-size: 1.4rem;
    line-height: 2.1rem;
    color: #545460;
    margin-top: 0.5rem;
  }
  .user {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding-top: 1rem;
    margin-top: 1.3rem;
    border-top: 1px solid #e2e2e2;
    .username {
      font-size: 1.3rem;
      line-height: 1.9rem;
      color: #000000;
    }
    img {
      width: 4.6rem;
      height: 4.6rem;
      border-radius: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bootcamp/enroll/testimonial/BootcampTestimonial.vue